import React from "react";
import { Constants } from "@eagerdog/constants";
import { IScore, IBarnHuntScore } from "@eagerdog/interfaces";

import InstinctForm from "./InstinctForm";
import StandardClassForm from "./StandardClassForm";
import LineDriveForm from "./LineDriveForm";
import Crazy8sForm from "./Crazy8sForm";

import "./BarnHuntResults.scss";

interface IProps {
  result: IScore;
  onChange(result: IBarnHuntScore): void;
}

const BarnHuntResults: React.FC<IProps> = (props) => {
  const level = props.result.dog_class?.level;

  // Route to the appropriate form based on class level
  switch (level) {
    case Constants.dog_class_element_level.barn_hunt_instinct:
      return <InstinctForm {...props} />;
    
    case Constants.dog_class_element_level.barn_hunt_novice:
    case Constants.dog_class_element_level.barn_hunt_open:
    case Constants.dog_class_element_level.barn_hunt_senior:
    case Constants.dog_class_element_level.barn_hunt_master:
      return <StandardClassForm {...props} />;
    
    case Constants.dog_class_element_level.barn_hunt_line_drive:
      return <LineDriveForm {...props} />;
    
    case Constants.dog_class_element_level.barn_hunt_crazy_8s:
      return <Crazy8sForm {...props} />;
    
    default:
      return <div>Unknown Barn Hunt class: {level}</div>;
  }
};

export default BarnHuntResults;

